import { supabase } from '../../lib/supabase';
export class ChatSendPendingError extends Error {
    override name = 'ChatSendPendingError';
}

/** A API pode ter aceitado a fila enquanto outro atendente ainda envia. Nunca repete o POST. */
export async function resolveChatSendReceipt<T extends Record<string, unknown>>(data: T, onAccepted?: () => void): Promise<T> {
    if (!data?.queued || typeof data.requestId !== 'string') return data;
    const deadline = Date.now() + 120_000;
    while (Date.now() < deadline) {
        let response;
        try {
            response = await supabase.from('chat_outbox').select('status,result,error').eq('id', data.requestId).maybeSingle();
        } catch {
            throw new ChatSendPendingError('Não foi possível confirmar o envio. Confira a conversa antes de reenviar.');
        }
        const { data: job, error } = response;
        if (error) throw new ChatSendPendingError('O envio foi enfileirado. Confira a conversa antes de tentar novamente.');
        if (!job) { await new Promise(resolve => setTimeout(resolve, 750)); continue; }
        onAccepted?.();
        onAccepted = undefined;
        if (job.status === 'sent') return job.result as T;
        if (job.status === 'failed') throw new Error(job.error || 'O provedor recusou o envio.');
        if (job.status === 'uncertain') throw new ChatSendPendingError('Confirmação do envio pendente. Confira o WhatsApp/Instagram antes de reenviar.');
        await new Promise(resolve => setTimeout(resolve, 750));
    }
    throw new ChatSendPendingError('O envio continua na fila. Confira a conversa antes de tentar novamente.');
}

export function recoverChatSendReceipt(requestId: string, onAccepted?: () => void): Promise<Record<string, unknown>> {
    return resolveChatSendReceipt({ queued: true, requestId }, onAccepted);
}

export async function acceptChatSendResponse<T extends Record<string, unknown>>(
    data: T | null, requestId: string, onAccepted?: () => void,
): Promise<T> {
    const hasId = data && [data.messageId, data.messageid, data.message_id, data.id, (data.key as { id?: string })?.id]
        .some(id => typeof id === 'string' && id.length > 0);
    if (!hasId && !(data?.queued && data.requestId === requestId)) {
        return await recoverChatSendReceipt(requestId, onAccepted) as T;
    }
    onAccepted?.();
    return resolveChatSendReceipt(data!);
}
